import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import VL06O00 from './../workinstructions/images/VL06O-00.png';
import VL06Oconfirmation from './../workinstructions/images/VL06Oconfirmation.png';
import VL06Oconfirmdeliveries01 from './../workinstructions/images/VL06Oconfirmdeliveries01.png';
import VL06Oconfirmdeliveries02 from './../workinstructions/images/VL06Oconfirmdeliveries02.png';
import VL06Oconfirmdeliveries03 from './../workinstructions/images/VL06Oconfirmdeliveries03.png';
import VL06Oconfirmdeliveries04 from './../workinstructions/images/VL06Oconfirmdeliveries04.png';
import VL06Oconfirmdeliveries05 from './../workinstructions/images/VL06Oconfirmdeliveries05.png';
import VL06Oconfirmpicking01 from './../workinstructions/images/VL06O-confirmpicking01.png';
import VL06Oconfirmpicking02 from './../workinstructions/images/VL06O-confirmpicking02.png';
import VL06Oconfirmpicking03 from './../workinstructions/images/VL06O-confirmpicking03.png';
//import VL06Otransportplanning01 from './../workinstructions/images/VL06O-transportplanning.png';
import VL06Otransportplanning02 from './../workinstructions/images/VL06O-transportplanning02.png';
import VL06Otransportplanning03 from './../workinstructions/images/VL06O-transportplanning03.png';

class ConfirmationDeliveries extends React.Component {
	async componentDidMount() {
    document.title = "Nokia MN Outbound";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>Deliveries' Confirmation</PanelHeader>
					<PanelBody>

						<h2>Confirmation of deliveries</h2>
						<p>
							Use LT24 =&gt; fill in the material of the concerning delivery =&gt; F8<br />
							look for destination of movement-type 916 for de delivery-nr =&gt; click on the material-code and confirmation<br />
							Use LT22 =&gt; fill in field "destination" the delivery-nr =&gt; F8 =&gt; confirmation<br />
							Use VL06O =&gt; select "For Confirmation" 
							<p> <img src={VL06Oconfirmation} alt="VL06O confirm deliveries" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							Type in FI29 at "Shipping Point" =&gt; F8 (Execute)
							<p> <img src={VL06Oconfirmdeliveries01} alt="VL06O Confirm deliveries after picking" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							you will see a list of deliveries
							<p> <img src={VL06Oconfirmdeliveries02} alt="VL06O list of deliveries for confirmation" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							click on label "deliveries" to mark =&gt; click on filter-icon 
							<p> <img src={VL06Oconfirmdeliveries03} alt="VL06O Confirm deliveries after picking" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							If you want to confirm mulitple deliveries then click on multiple selection like in the image =&gt; fill in the deliveries in the inputfields =&gt Execute after finishing fill in the deliveries
							<p> <img src={VL06Oconfirmdeliveries04} alt="VL06O Confirm deliveries after picking" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							select the deliveries =&gt; then press F7 or click on confirmation-icon
							<p> <img src={VL06Oconfirmdeliveries05} alt="VL06O Confirm deliveries after picking" style={{ maxWidth: '100%', height: 'auto' }} /> </p>

						</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; Nov 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default ConfirmationDeliveries;
